import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVault: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVault"><Path d="M6.5 18.375H3.5V3.5H20.5V18.375H17.5M6.5 18.375V20.5M6.5 18.375H17.5M17.5 18.375V20.5M11.5 11H7.75M16.5 11C16.5 13.4853 14.4853 15.5 12 15.5C9.51472 15.5 7.5 13.4853 7.5 11C7.5 8.51472 9.51472 6.5 12 6.5C14.4853 6.5 16.5 8.51472 16.5 11Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVault;
